import { SystemStyleObject } from "@chakra-ui/theme-tools";
import { colors } from "../foundations/colors";
import { shadows } from "../foundations/shadows";

export const reactDayPickerStyles: SystemStyleObject = {
  ".rdp-root": {
    "--rdp-accent-color": colors.primary[500],
    "--rdp-accent-background-color": colors.primary[50],
    "--rdp-today-color": colors.primary[500],
    "--rdp-day-width": "50px",
    // height is a bit smaller to save vertical space
    "--rdp-day-height": "36px",
    "--rdp-day_button-height": "36px",
    fontFamily: "body",
    fontWeight: "normal",
    color: "gray.800",
    backgroundColor: "transparent",
  },

  ".rdp-day_button": {
    fontSize: "sm",
    borderRadius: "md",
  },

  ".rdp-day_button:focus": {
    outline: "none",
    boxShadow: "none",
  },

  ".rdp-day_button:focus-visible": {
    outline: "none",
    boxShadow: shadows.outline,
  },

  ".rdp-day_button:hover:not([disabled])": {
    backgroundColor: "primary.100",
  },

  ".rdp-selected .rdp-day_button:hover:not([disabled])": {
    backgroundColor: "primary.200",
  },

  ".rdp-selected": {
    fontWeight: "bold",
  },

  ".rdp-selected.rdp-outside": {
    fontWeight: "normal",
  },

  ".rdp-selected .rdp-day_button": {
    backgroundColor: "primary.500",
    color: "white",
    borderWidth: "0px",
  },

  ".rdp-selected.rdp-range_start .rdp-day_button, .rdp-selected.rdp-range_end .rdp-day_button":
    {
      backgroundColor: "primary.500",
      color: "white",
      borderWidth: "0px",
    },

  ".rdp-selected.rdp-range_middle .rdp-day_button": {
    backgroundColor: "primary.50",
    color: "gray.700",
  },

  ".rdp-selected.rdp-outside:is(.rdp-range_start, .rdp-range_end, .rdp-range_middle), .rdp-selected.rdp-outside:is(.rdp-range_middle, .rdp-range_start, .rdp-range_end) .rdp-day_button":
    {
      background: "none",
      backgroundColor: "white",
      color: "gray.400",
    },

  ".rdp-outside .rdp-day_button": {
    color: "gray.400",
  },

  ".rdp-selected.rdp-outside .rdp-day_button": {
    color: "white",
  },

  ".rdp-disabled .rdp-day_button": {
    color: "gray.300",
  },

  ".rdp-months": {
    justifyContent: "center",
    backgroundColor: "transparent",
  },

  ".rdp-month": {
    backgroundColor: "transparent",
  },

  ".rdp-weekday": {
    color: "gray.500",
    fontWeight: "medium",
  },

  ".rdp-button_previous, .rdp-button_next": {
    color: "gray.700",
    borderRadius: "md",
  },

  ".rdp-button_previous:focus, .rdp-button_next:focus": {
    outline: "none",
    boxShadow: "none",
  },

  ".rdp-button_previous:focus-visible, .rdp-button_next:focus-visible": {
    outline: "none",
    boxShadow: shadows.outline,
  },

  ".rdp-button_previous:hover, .rdp-button_next:hover": {
    backgroundColor: "gray.100",
  },
};
